import environment from 'environment';
import { getRequest, postRequest } from '..';

const { RBI_BASE_URL } = environment.eCommerce;

export const rbiGetRequest = getRequest(RBI_BASE_URL);
export const rbiPostRequest = postRequest(RBI_BASE_URL);

export const getRemediationReasons = async ({ simplrAccountId, brandName, customerId }) => {
  const query = {
    simplrAccountId,
    brandName,
    customerId,
  };

  return await rbiGetRequest('/remediationReasons', query);
};

export const getRemediations = async ({ simplrAccountId, customerEmail, brandName, lastDays }) => {
  const query = {
    simplrAccountId,
    customerEmail,
    brandName,
    lastDays,
  };

  return await rbiGetRequest('/remediations', query);
};

export const fetchRbiHockeyChallengeInfo = async (simplrAccountId, domain, brandName, customerId) => {
  const query = {
    simplrAccountId,
    domain,
    brandName,
    customerId,
  };

  return await rbiGetRequest('/get-hockey-challenges', query);
};

export const fetchRbiChallengeInfo = async (simplrAccountId, domain, brandName, email) => {
  const query = {
    simplrAccountId,
    domain,
    brandName,
    email,
  };

  return await rbiGetRequest('/challenges', query);
};
